import type { QuoterMode } from "../components/QuoterStep1";

export interface QuoteBreakdown {
  amount_sent: number;
  amount_received: number;
}

export interface QuoteFees {
  fixed_fee: number;
  percentage_fee: number;
  total_fee: number;
}

export function computeQuoteFromCommission(
  rate: number,
  amount: number,
  mode: QuoterMode,
  commissionPercent: number
): { breakdown: QuoteBreakdown; fees: QuoteFees } {
  const pct = Math.max(0, Math.min(100, commissionPercent)) / 100;
  const fixed_fee = 0;

  if (mode === "send") {
    const amount_sent = amount;
    const amount_converted = amount_sent * rate;
    const total_fee = amount_converted * pct;
    const amount_received = amount_converted - total_fee;
    return {
      breakdown: { amount_sent, amount_received },
      fees: { fixed_fee, percentage_fee: commissionPercent, total_fee },
    };
  }

  const amount_received = amount;
  const amount_converted = pct >= 1 ? amount_received : amount_received / (1 - pct);
  const total_fee = amount_converted - amount_received;
  const amount_sent = rate > 0 ? amount_converted / rate : 0;
  return {
    breakdown: { amount_sent, amount_received },
    fees: { fixed_fee, percentage_fee: commissionPercent, total_fee },
  };
}

export function isQuoteFeesBreakdownZero(
  fees: { total_fee: number; percentage_fee?: number },
  breakdown: { amount_sent: number; amount_received: number }
): boolean {
  return (
    fees.total_fee === 0 &&
    breakdown.amount_sent === 0 &&
    breakdown.amount_received === 0
  );
}
